import {useMutation, useQueryClient} from "@tanstack/react-query";
import {REPORT_ENDPOINTS} from "../../services/network/endpoints";
import {toast} from "react-toastify";
import {ReportAPI} from "../../services/network/report-api";
import {IReport} from "../../services/models/report";

export function useUpsertReport() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [REPORT_ENDPOINTS.UPSERT],
        mutationFn: (data: IReport) => ReportAPI.upsert(data),
        onError() {
            toast.error("Ошибка сохранения отчета");
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: [
                    REPORT_ENDPOINTS.FETCH,
                    variables.reportingWeek,
                    variables.reportingYear,
                    variables.owner
                ]
            });
            toast.success("Отчет успешно сохранен");
        }
    });
}